import Link from "next/link"

import { Advice } from "../types"

interface Props {
    advice: Advice
}

export function AdviceCell(props: Props) {
    const { advice } = props
    return (
        <details>
            <summary className="cursor-pointer text-lg font-semibold">
                {advice.title.startsWith('http')
                    ? advice.title
                    : advice.title.split('http')[0]}
            </summary>
            <div className="p-2">
                <h3 className="font-bold">
                    Description:
                </h3>
                {advice.description}
            </div>
            <div className="p-2">
                {
                    <Link
                        href={`/${advice.categories[0].slug}/${advice.topics[0].slug}/${advice.slug}`}
                        className="text-blue-600 hover:text-blue-800 underline"
                    >
                        {advice.slug}
                    </Link>
                }
            </div>
        </details>
    )
}